var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35449 5.00244H2.97919H15.9768",
    strokeWidth: 1.6247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41654 5.00233V3.37763C5.41654 2.94673 5.58771 2.53348 5.8924 2.22879C6.1971 1.9241 6.61034 1.75293 7.04124 1.75293H10.2906C10.7215 1.75293 11.1348 1.9241 11.4395 2.22879C11.7442 2.53348 11.9153 2.94673 11.9153 3.37763V5.00233M14.3524 5.00233V16.3752C14.3524 16.8061 14.1812 17.2194 13.8765 17.5241C13.5718 17.8287 13.1586 17.9999 12.7277 17.9999H4.60419C4.17329 17.9999 3.76005 17.8287 3.45536 17.5241C3.15067 17.2194 2.97949 16.8061 2.97949 16.3752V5.00233H14.3524Z",
    strokeWidth: 1.6247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04102 9.06396V13.9381",
    strokeWidth: 1.6247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.291 9.06396V13.9381",
    strokeWidth: 1.6247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.c61f170add99dcc1b1024930d1cc0cbe.svg";
export { ForwardRef as ReactComponent };